import httpClient from "@/apis/httpClient"
import { useQuery } from "@tanstack/react-query"
import storeUtils from "../utils/store.utils"
import qs from "query-string"
import { isAxiosError } from 'axios'
import type { StoreItem } from './useStore'

interface StoreParams {
  id?: string | number
  storeNo?: string | number
}

interface StoreApiError {
  error?: {
    code?: number
    message?: string
  }
}

export const useGetStore = (params: StoreParams, options?) => {
  return useQuery<StoreItem | undefined>({
    queryKey: ["useGetStore", params],
    queryFn: async () => {
      try {
        const queryString = qs.stringify({
          id: params?.id,
          storeNo: params?.storeNo,
        }, {
          skipEmptyString: true,
          skipNull: true,
        })

        const response = await httpClient.get(`/api/v1/Store/Get?${queryString}`)

        return storeUtils.formatStore(response?.data?.result?.store)
      } catch (error: unknown) {
        const apiError = isAxiosError<StoreApiError>(error)
          ? error.response?.data?.error
          : undefined
        const code = apiError?.code
        const message = apiError?.message
        if (code === 0) {
          throw new Error(message)
        }

        throw error instanceof Error
          ? error
          : new Error(message || 'Không thể tải thông tin cửa hàng')
      }
    },
    ...options,
  })
}
